export default {
	"presets": {
		"GPDPP": {
			"ASHRAE_Low": {
				"label": "ASHRAE Low",
				"value": 20,
				"pos": "40%"
			},
			"MarketRate": {
				"label": "Ecotope Market Rate with Low Flow Fixtures",
				"value": 25,
				"pos": "50%"
			},
			"ASHRAE_Medium": {
				"label": "ASHRAE Medium",
				"value": 49,
				"pos": "100%"
			}
		},
		"RBR": {
			"ASHSTD": {
				"label": "ASHRAE Market Rate",
				"value": [1.49, 1.93, 2.39, 2.84, 3.29, 3.74]
			},
			"ASHLOW": {
				"label": "ASHRAE Low Income",
				"value": [1.69, 2.26, 2.83, 3.40, 3.97, 4.54]
			},
			"CA": {
				"label": "California - RASS Data",
				"value": [1.37, 1.74, 2.57, 3.11, 4.23, 3.77]
			},
			"CTCAC": {
				"label": "California Tax Credit Allocation Committee",
				"value": [1, 1.5, 3, 4.5, 6, 7.5]
			}
		}
	},
	"customLoad": {
		"label": "Custom Hot Water Load",
		"desc": "",
		"definition": "<ul><li><strong>Calculate only this Custom Load (disable Multifamily Load)</strong><br>Disables the multifamily load (next section) and only uses these hourly load inputs.</li><li><strong>Add Custom Load to Multifamily Load</strong><br>Combines the custom load added via these hourly inputs and the multifamily load (next section).</li><li><strong>Multifamily Load only (disable Custom Load)</strong><br>Disables the hourly load inputs in this section and calculates just the multifamily load. We’ll remember your custom load settings if you decide to turn them back on.</li></ul>"
	},
	"customLoad_hours": {
		"default": "",
		"AbsMin": 0,
		"ExpMin": 0,
		"ExpMax": 5000,
		"AbsMax": 10000
	},
	"CAspec": {
		"label": "California Specification Mode",
		"desc": "Use hot water draws and occupancy data from CBECC-Res",
		"definition": "This toggle sets the selection of your inputs to match the inputs given in the CA Compliance Software CBECC-Res 19.1.2, by aligning the hot water draws, the occupancy ratios, and the supply temperature."
	},
	"inputmethod": {
		"label": "Input Method",
		"desc": "Toggle between inputs for the total number of people and apartments or the number of apartments by size",
		"definition": "These options allow you to toggle between two ways to provide number of people (building occupants) and number of apartments information.Using <strong>Total People & Apartments</strong> requires just those two values.Using <strong>Apartment Size & Occupancy Rates</strong> allows more control over apartment types, occupancy rates (people per unit size), and gallons of hot water used per day per person. Suggested values are also provided from California and ASHRAE occupancy data."
	},
	"buildingType": {
		"label": "Building Type",
		"label_trunc": "Building Type",
		"desc": "Select a type of building to be sized",
		"definition": "Type of building to be sized.",
		"default": "multifamily",
		"value_desc": {
			"multi_family": "Market rate multifamily building load shape based on Ecotope research. Total hot water usage is based on the number of people and gallons used per person per day from inputs below.",
			"mens_dorm": "Men's dormitories load shape and gallons per day based on ASHRAE 2023 Applications Handbook Chapter 51 figure 33",
			"womens_dorm": "Women's dormitories load shape and gallons per day based on ASHRAE 2023 Applications Handbook Chapter 51 figure 33",
			"motel": "Motel load shape and gallons per day based on ASHRAE 2023 Applications Handbook Chapter 51 figure 33",
			"elementary_school": "Elementary school load shape and gallons per day based on ASHRAE 2023 Applications Handbook Chapter 51 figure 33",
			"junior_high": "Junior high school load shape and gallons per day based on ASHRAE 2023 Applications Handbook Chapter 51 figure 33",
			"senior_high": "Senior high school load shape and gallons per day based on ASHRAE 2023 Applications Handbook Chapter 51 figure 33",
			"nursing_home": "Nursing home load shape and gallons per day based on ASHRAE 2023 Applications Handbook Chapter 51 figure 33",
			"food_service_a": "Food Service (Type A - ) load shape and gallons per day based on ASHRAE 2023 Applications Handbook Chapter 51 figure 33",
			"food_service_b": "Food Service (Type B - ) load shape and gallons per day based on ASHRAE 2023 Applications Handbook Chapter 51 figure 33",
			"office_building": 'Office building load shape and gallons per day based on ASHRAE 2023 Applications Handbook Chapter 51 figure 33',
			"apartment": "Apartment load shape and gallons per day based on ASHRAE 2023 Applications Handbook Chapter 51 figure 33"
		}
	},
	"nPeople": {
		"label": "Number of people",
		"label_trunc": "Number of People",
		"desc": "Total number of people in the building served by the domestic hot water system",
		"definition": "Total number of people in the building served by the domestic hot water system. Load shape based on Ecotope research. ",
		"context": "The number of people is multiplied by the gallons per person to get peak daily usage. The daily profile for this sizing methods is derived from Ecotope research.",
		"default": "",
		"AbsMin": 1.00,
		"ExpMin": 20.00,
		"ExpMax": 2000.00,
		"AbsMax": 10000.00,
		"warningMin": "The calculations may not be as accurate for small buildings. This method assumes a typical amount of diversity in hot water use by people in the building. If everyone uses water at the same time it will require a larger storage volume. Check the documentation for the load shape used."
	},
	"nApt": {
		"label": "Number of apartments",
		"label_trunc": "Number of apartments",
		"desc": "Number of apartments in the building",
		"definition": "Total number of apartment units in the building.",
		"context": "An increase in the number of apartments in a building will result in increased temperature maintenance losses for a given Recirculation Loop Heat Loss.",
		"AbsMin": 1,
		"ExpMin": 12,
		"ExpMax": 1000,
		"AbsMax": 2000,
		"warningMin": "The calculations may not be as accurate for small buildings. This method assumes a typical amount of diversity in hot water use by people in the building. If everyone uses water at the same time it will require a larger storage volume. Check the documentation for the load shape used."
	},
	"nMensDorm": {
		"label": "Number of students",
		"label_trunc": "Number of students",
		"desc": "Total number of dorm rooms in the building served by the HPWH",
		"definition": "Total number of dorm rooms in the building served by the heat pump water heater.",
		"context": "The peak daily usage and load shape are derived from ASHRAE Applications Handbook 2019.",
		"default": "",
		"AbsMin": 1.00,
		"ExpMin": 12.00,
		"ExpMax": 2000.00,
		"AbsMax": 10000.00,
		"warningMin": "The calculations may not be as accurate for small buildings. This method assumes a typical amount of diversity in hot water use by people in the building. If everyone uses water at the same time it will require a larger storage volume. Check the documentation for the load shape used."
	},
	"nWomensDorm": {
		"label": "Number of students",
		"label_trunc": "Number of students",
		"desc": "Total number of dorm rooms in the building served by the HPWH",
		"definition": "Total number of dorm rooms in the building served by the heat pump water heater.",
		"context": "The peak daily usage and load shape are derived from ASHRAE Applications Handbook 2019.",
		"default": "",
		"AbsMin": 1.00,
		"ExpMin": 12.00,
		"ExpMax": 2000.00,
		"AbsMax": 10000.00,
		"warningMin": "The calculations may not be as accurate for small buildings. This method assumes a typical amount of diversity in hot water use by people in the building. If everyone uses water at the same time it will require a larger storage volume. Check the documentation for the load shape used."
	},
	"nMotel": {
		"label": "Number of rooms",
		"label_trunc": "Number of<br/> rooms",
		"desc": "Total number of rooms in the building served by the HPWH",
		"definition": "Total number of rooms in the building served by the heat pump water heater.",
		"context": "The peak daily usage and load shape are derived from ASHRAE Applications Handbook 2019.",
		"default": "",
		"AbsMin": 1.00,
		"ExpMin": 12.00,
		"ExpMax": 2000.00,
		"AbsMax": 10000.00,
		"warningMin": "The calculations may not be as accurate for small buildings. This method assumes a typical amount of diversity in hot water use by people in the building. If everyone uses water at the same time it will require a larger storage volume. Check the documentation for the load shape used."
	},
	"nElemSchool": {
		"label": "Number of students",
		"label_trunc": "Number of<br/> students",
		"desc": "Total number of students in the building served by the HPWH",
		"definition": "Total number of students in the building served by the heat pump water heater.",
		"context": "The peak daily usage and load shape are derived from ASHRAE Applications Handbook 2019.",
		"default": "",
		"AbsMin": 1.00,
		"ExpMin": 30.00,
		"ExpMax": 2000.00,
		"AbsMax": 10000.00,
		"warningMin": "The calculations may not be as accurate for small buildings. This method assumes a typical amount of diversity in hot water use by people in the building. If everyone uses water at the same time it will require a larger storage volume. Check the documentation for the load shape used."
	},
	"nJrHigh": {
		"label": "Number of students",
		"label_trunc": "Number of<br/> students",
		"desc": "Total number of students in the building served by the HPWH",
		"definition": "Total number of students in the building served by the heat pump water heater.",
		"context": "The peak daily usage and load shape are derived from ASHRAE Applications Handbook 2019.",
		"default": "",
		"AbsMin": 1.00,
		"ExpMin": 30.00,
		"ExpMax": 2000.00,
		"AbsMax": 10000.00,
		"warningMin": "The calculations may not be as accurate for small buildings. This method assumes a typical amount of diversity in hot water use by people in the building. If everyone uses water at the same time it will require a larger storage volume. Check the documentation for the load shape used."
	},
	"nSrHigh": {
		"label": "Number of students",
		"label_trunc": "Number of<br/> students",
		"desc": "Total number of students in the building served by the HPWH",
		"definition": "Total number of students in the building served by the heat pump water heater.",
		"context": "The peak daily usage and load shape are derived from ASHRAE Applications Handbook 2019.",
		"default": "",
		"AbsMin": 1.00,
		"ExpMin": 30.00,
		"ExpMax": 2000.00,
		"AbsMax": 10000.00,
		"warningMin": "The calculations may not be as accurate for small buildings. This method assumes a typical amount of diversity in hot water use by people in the building. If everyone uses water at the same time it will require a larger storage volume. Check the documentation for the load shape used."
	},
	"nNursingHome": {
		"label": "Number of beds",
		"label_trunc": "Number of<br/> beds",
		"desc": "Total number of beds in the building served by the HPWH",
		"definition": "Total number of beds in the building served by the heat pump water heater.",
		"context": "The peak daily usage and load shape are derived from ASHRAE Applications Handbook 2019.",
		"default": "",
		"AbsMin": 1.00,
		"ExpMin": 20.00,
		"ExpMax": 2000.00,
		"AbsMax": 10000.00,
		"warningMin": "The calculations may not be as accurate for small buildings. Check the documentation for the load shape used."
	},
	"nFoodSvcA": {
		"label": "Maximum number of meals per hour",
		"label_trunc": "Maximum number of<br/> meals per hour",
		"desc": "Maximum number of meals per hour in the building served by the HPWH",
		"definition": "Maximum number of meals per hour in the building served by the heat pump water heater.",
		"context": "The peak daily usage and load shape are derived from ASHRAE Applications Handbook 2019.",
		"default": "",
		"AbsMin": 1.00,
		"ExpMin": 20.00,
		"ExpMax": 5000.00,
		"AbsMax": 100000.00,
		"warningMin": "The calculations may not be as accurate for small buildings. Check the documentation for the load shape used."
	},
	"nFoodSvcB": {
		"label": "Maximum number of meals per hour",
		"label_trunc": "Maximum number of<br/> meals per hour",
		"desc": "Maximum number of meals per hour in the building served by the HPWH",
		"definition": "Maximum number of meals per hour in the building served by the heat pump water heater.",
		"context": "The peak daily usage and load shape are derived from ASHRAE Applications Handbook 2019.",
		"default": "",
		"AbsMin": 1.00,
		"ExpMin": 20.00,
		"ExpMax": 5000.00,
		"AbsMax": 100000.00,
		"warningMin": "The calculations may not be as accurate for small buildings. This method assumes a typical amount of diversity in hot water use by people in the building. If everyone uses water at the same time it will require a larger storage volume. Check the documentation for the load shape used."
	},
	"nAptAsh": {
		"label": "Number of apartments",
		"label_trunc": "Number of<br/> apartments",
		"desc": "Total number of apartments in the building served by the HPWH",
		"definition": "Total number of apartments in the building served by the heat pump water heater.",
		"context": "The peak daily usage and load shape are derived from ASHRAE Applications Handbook 2019.",
		"default": "",
		"AbsMin": 1.00,
		"ExpMin": 20.00,
		"ExpMax": 2000.00,
		"AbsMax": 10000.00,
		"warningMin": "The calculations may not be as accurate for small buildings. This method assumes a typical amount of diversity in hot water use by people in the building. If everyone uses water at the same time it will require a larger storage volume. Check the documentation for the load shape used."
	},
	"nOffice": {
		"label": "Number of people",
		"label_trunc": "Number of<br/> people",
		"desc": "Total number of people in the office building served by the HPWH",
		"definition": "Total number of people in the office building served by the heat pump water heater.",
		"context": "The peak daily usage and load shape are derived from ASHRAE Applications Handbook 2019.",
		"default": "",
		"AbsMin": 1.00,
		"ExpMin": 20.00,
		"ExpMax": 2000.00,
		"AbsMax": 10000.00,
		"warningMin": "The calculations may not be as accurate for small buildings. This method assumes a typical amount of diversity in hot water use by people in the building. If everyone uses water at the same time it will require a larger storage volume. Check the documentation for the load shape used."
	},

	"gpdpp": {
		"label": "Peak Gallons per Day per Person",
		"desc": "The volume of hot water used per person on the highest use day",
		"definition": "Use this area to provide information on the maximum gallons of hot water used per day by each building occupant.The <strong>User Defined</strong> option allows you to choose a value of your choice between 20 and 49 gallons per day per person. Using the <strong>California By Bedroom</strong> option is only possible when entering the number of units by size (input method), as each unit will have a different value aligned with the Title 24 Software CBECC-Res. Using this method means also using the CA occupancy ratios.<strong>ASHRAE Low</strong> is described as an apartment building with a mix of demographics: all occupants working; one person working, while one stays at home; seniors; couples; middle income; higher population density.<strong>Ecotope Market Rate with Low Flow Fixtures</strong> is based upon measured data from an Ecotope Inc. project, Stream Uptown, a building with 118 units. Data uses the 100% quantile for the peak draws during the given time periods.<strong>ASHRAE Medium</strong> is associated with apartment buildings with a mix of occupant demographics: families; singles; on public assistance; single-parent households.",
		"context": "The number of people is needed to define how much hot water is used daily.",
		"reference": "<ul><li><a href=\"http://www.bwilcox.com/BEES/cbecc2019.html\" target = \"_blank\">http://www.bwilcox.com/BEES/cbecc2019.html</a>\n<li>2015 ASHRAE HVAC Applications - Table 7, pg. 50.15.</li></ul>",
		"AbsMin": 1,
		"ExpMin": 15,
		"ExpMax": 49,
		"AbsMax": 49,
		"warningMin": "This value is meant to be the peak gallons per day per person, not the average. The ASHRAE standard uses 20 gpdpp on the low end use, we recommend 25 gallon per day per person.",
		"default": 25,
		"default_CA": "CA"
	},
	"RBR_presets": {
		"label": "Occupancy Rate",
		"desc": "The average number of people in the apartment type",
		"definition": "Use this area to provide information on the number of people per apartment type. There are several default options provided. The User Defined option allows you to choose a value of your choice for each applicable apartment type.",
		"reference": "<ul><li>Palmgren, C., N. Stevens, M. Goldberg, R. Bames, and K. Rothkin (2010). 2009 California Residential Appliance Saturation Survey. Technical report, KEEMA, Inc., Oakland, California.<li>Florida Solar Energy Center. <i>Estimating Daily Domestic Hot-Water Use in North American Homes.</i> FSEC-PF-464-15. June 30, 2015. <a href=\"https://fsec.ucf.edu/en/publications/pdf/FSEC-PF-464-15.pdf\" target = \"_blank\">www.fsec.ucf.edu/en/publications/pdf/FSEC-PF-464-15.pdf</a></li></ul>"
	},
	"gpdppptionsBR": {
		"label": "Peak Gallons per Day per Person"
	},
	"nBR0": {
		"label": "Number of Apartments / Studio",
		"desc": "",
		"AbsMin": 0,
		"ExpMin": 0,
		"ExpMax": 1200,
		"AbsMax": 2000,
		"default": 0,
		"default_CA": 0
	},
	"rBR0": {
		"label": "Occupancy Rate / Studio",
		"desc": "The average number of people in the apartment type",
		"AbsMin": 0.1,
		"ExpMin": 1,
		"ExpMax": 2,
		"AbsMax": 10,
		"warningMin": "The calculations may not be as accurate for small buildings. This method assumes a typical amount of diversity in hot water use by people in the building. If everyone uses water at the same time it will require a larger storage volume. Check the documentation for the load shape used.",
		"default": 1.49,
		"default_CA": 1.37
	},
	"gBR0": {
		"label": "Peak Gallons per Day per Person / Studio",
		"desc": "",
		"AbsMin": 1,
		"ExpMin": 15,
		"ExpMax": 49,
		"AbsMax": 49,
		"warningMin": "This value is meant to be the peak gallons per day per person, not the average. The ASHRAE standard uses 20 gpdpp on the low end use, we recommend 25 gallon per day per person.",
		"default": 25,
		"default_CA": 0
	},
	"nBR1": {
		"label": "Number of Apartments / 1 Bedroom",
		"desc": "",
		"AbsMin": 0,
		"ExpMin": 0,
		"ExpMax": 1200,
		"AbsMax": 2000,
		"default": 0,
		"default_CA": 0
	},
	"rBR1": {
		"label": "Occupancy Rate / 1 Bedroom",
		"desc": "The average number of people in the apartment type",
		"AbsMin": 0.1,
		"ExpMin": 1,
		"ExpMax": 3.00,
		"AbsMax": 10.00,
		"warningMin": "The calculations may not be as accurate for small buildings. This method assumes a typical amount of diversity in hot water use by people in the building. If everyone uses water at the same time it will require a larger storage volume. Check the documentation for the load shape used.",
		"default": 1.93,
		"default_CA": 1.74
	},
	"gBR1": {
		"label": "Peak Gallons per Day per Person / 1 Bedroom",
		"desc": "",
		"AbsMin": 1.00,
		"ExpMin": 15.00,
		"ExpMax": 49.00,
		"AbsMax": 49.00,
		"warningMin": "This value is meant to be the peak gallons per day per person, not the average. The ASHRAE standard uses 20 gpdpp on the low end use, we recommend 25 gallon per day per person.",
		"default": 25,
		"default_CA": 0
	},
	"nBR2": {
		"label": "Number of Apartments / 2 Bedroom",
		"desc": "",
		"AbsMin": 0,
		"ExpMin": 0,
		"ExpMax": 1200,
		"AbsMax": 2000,
		"default": 0,
		"default_CA": 0
	},
	"rBR2": {
		"label": "Occupancy Rate / 2 Bedroom",
		"desc": "The average number of people in the apartment type",
		"AbsMin": 0.1,
		"ExpMin": 1.00,
		"ExpMax": 4.00,
		"AbsMax": 10.00,
		"warningMin": "The calculations may not be as accurate for small buildings. This method assumes a typical amount of diversity in hot water use by people in the building. If everyone uses water at the same time it will require a larger storage volume. Check the documentation for the load shape used.",
		"default": 2.39,
		"default_CA": 2.57
	},
	"gBR2": {
		"label": "Peak Gallons per Day per Person / 2 Bedroom",
		"desc": "",
		"AbsMin": 1,
		"ExpMin": 15.00,
		"ExpMax": 49.00,
		"AbsMax": 49.00,
		"warningMin": "This value is meant to be the peak gallons per day per person, not the average. The ASHRAE standard uses 20 gpdpp on the low end use, we recommend 25 gallon per day per person.",
		"default": 25,
		"default_CA": 0
	},
	"nBR3": {
		"label": "Number of Apartments / 3 Bedroom",
		"desc": "",
		"AbsMin": 0,
		"ExpMin": 0,
		"ExpMax": 1200,
		"AbsMax": 2000,
		"default": 0,
		"default_CA": 0
	},
	"rBR3": {
		"label": "Occupancy Rate / 3 Bedroom",
		"desc": "The average number of people in the apartment type",
		"AbsMin": 0.1,
		"ExpMin": 1.00,
		"ExpMax": 6.00,
		"AbsMax": 10.00,
		"warningMin": "The calculations may not be as accurate for small buildings. This method assumes a typical amount of diversity in hot water use by people in the building. If everyone uses water at the same time it will require a larger storage volume. Check the documentation for the load shape used.",
		"default": 2.84,
		"default_CA": 3.11
	},
	"gBR3": {
		"label": "Peak Gallons per Day per Person / 3 Bedroom",
		"desc": "",
		"AbsMin": 1,
		"ExpMin": 15.00,
		"ExpMax": 38.00,
		"AbsMax": 49.00,
		"warningMin": "This value is meant to be the peak gallons per day per person, not the average. The ASHRAE standard uses 20 gpdpp on the low end use, we recommend 25 gallon per day per person.",
		"default": 25,
		"default_CA": 0
	},
	"nBR4": {
		"label": "Number of Apartments / 4 Bedroom",
		"desc": "",
		"AbsMin": 0,
		"ExpMin": 0,
		"ExpMax": 1200,
		"AbsMax": 2000,
		"default": 0,
		"default_CA": 0
	},
	"rBR4": {
		"label": "Occupancy Rate / 4 Bedroom",
		"desc": "The average number of people in the apartment type",
		"AbsMin": 0.1,
		"ExpMin": 1.00,
		"ExpMax": 8.00,
		"AbsMax": 10.00,
		"warningMin": "The calculations may not be as accurate for small buildings. This method assumes a typical amount of diversity in hot water use by people in the building. If everyone uses water at the same time it will require a larger storage volume. Check the documentation for the load shape used.",
		"default": 3.29,
		"default_CA": 4.23
	},
	"gBR4": {
		"label": "Peak Gallons per Day per Person / 4 Bedroom",
		"desc": "",
		"AbsMin": 1,
		"ExpMin": 15.00,
		"ExpMax": 49.00,
		"AbsMax": 49.00,
		"warningMin": "This value is meant to be the peak gallons per day per person, not the average. The ASHRAE standard uses 20 gpdpp on the low end use, we recommend 25 gallon per day per person.",
		"default": 25,
		"default_CA": 0
	},
	"nBR5": {
		"label": "Number of Apartments / 5 Bedroom",
		"desc": "",
		"AbsMin": 0,
		"ExpMin": 0,
		"ExpMax": 1200,
		"AbsMax": 2000,
		"default": 0,
		"default_CA": 0
	},
	"rBR5": {
		"label": "Occupancy Rate / 5 Bedroom",
		"desc": "The average number of people in the apartment type",
		"AbsMin": 0.1,
		"ExpMin": 1.00,
		"ExpMax": 8.00,
		"AbsMax": 10.00,
		"warningMin": "The calculations may not be as accurate for small buildings. This method assumes a typical amount of diversity in hot water use by people in the building. If everyone uses water at the same time it will require a larger storage volume. Check the documentation for the load shape used.",
		"default": 3.74,
		"default_CA": 3.77
	},
	"gBR5": {
		"label": "Peak Gallons per Day per Person / 5 Bedroom",
		"desc": "",
		"AbsMin": 1,
		"ExpMin": 15.00,
		"ExpMax": 49.00,
		"AbsMax": 49.00,
		"warningMin": "This value is meant to be the peak gallons per day per person, not the average. The ASHRAE standard uses 20 gpdpp on the low end use, we recommend 25 gallon per day per person.",
		"default": 25,
		"default_CA": 0
	},
	"incomingT": {
		"label": "Design Cold Water Temperature",
		"label_trunc": "Design Cold",
		"desc": "The coldest water supplied by the city",
		"definition": "This is the coldest water temperature supplied by incoming city water.",
		"context": "Increasing this value means the HPWH has a lower temperature lift to the hot water supply temperature, and the required heating capacity will decrease.",
		"AbsMin": 32,
		"ExpMin": 35,
		"ExpMax": 85,
		"AbsMax": 212,
		"warningMin": "",
		"warningMax": "The design cold water temperature is meant to be the coldest water coming from the city the HPWHs will have to lift. Even the hottest place on Earth gets below freezing in the winter.",
		"errors": {
			"high": "[incomingT.label] must be less than [supplyT.label]."
		},
		"default": 50,
		"default_CA": 50
	},
	"supplyT": {
		"label": "Supply Water Temperature",
		"label_trunc": "Supply",
		"desc": "The temperature of hot water supplied to building occupants",
		"definition": "This is the water temperature supplied to the building occupants from the hot water system/plant. The default is set to 120F, an industry standard. If you are aligning sizing efforts with CA Title 24 software this should be increased to 125F.",
		"context": "Increasing the supply water temperature raises the reference temperature for what the occupants use. This will increase the storage volume as the hot water stored has less potential energy over the supply water temperature.",
		"AbsMin": 32,
		"ExpMin": 120,
		"ExpMax": 125,
		"AbsMax": 212,
		"warningMin": "Water colder than 120°F is likely to feel too cold to occupants – we reccomend making the Supply Water Temperature at least 125°F.",
		"warningMax": "",
		"errors": {
			"low": "[supplyT.label] must be greater than [incomingT.label].",
			"high": "[supplyT.label] must be less than [storageT.label].",
			"lessthan": "[supplyT.label] must be less than or equal to [TMonTemp.label] ([TMonTemp.value])."
		},
		"default": 120,
		"default_CA": 125
	},
	"storageT": {
		"label": "Hot Water Storage Temperature",
		"label_trunc": "Hot Storage",
		"desc": "The setpoint of the primary HPWHs",
		"definition": "This is the setpoint temperature of the primary heat pump water heaters, or the hottest temperature provided by the primary heat pump equipment. There is no default. If you are designing a swing tank system you should use at least 140F.",
		"AbsMin": 32,
		"ExpMin": 120,
		"ExpMax": 185,
		"AbsMax": 212,
		"warningMin": "",
		"warningMax": "HPWH's are not able to make water hotter than 185 °F, yet.",
		"errors": {
			"low": "[storageT.label] must be greater than [supplyT.label]."
		},
		"default": "",
		"default_CA": ""
	},
	"lsLoadUp_TempSetHPWHOut": {
		"label": "Load Up Temperature",
		"label_trunc": "Load Up Temperature",
		"desc": "The setpoint of the primary HPWHs during load up periods",
		"definition": "This is the load up setpoint temperature of the primary heat pump water heaters, or the hottest temperature provided by the primary heat pump equipment during a load up period.",
		"AbsMin": 32,
		"ExpMin": 120,
		"ExpMax": 212,
		"AbsMax": 212,
		"errors": {
			"low": "[lsLoadUp_TempSetHPWHOut.label] must be greater than [storageT.label]."
		},
		"default": "",
		"default_CA": ""
	},
	"percentUseable": {
		"label": "Drawdown",
		"desc": "The fraction of primary storage filled with hot water at the storage temperature",
		"definition": "This is the fraction of the primary storage volume that is filled with hot water at the storage temperature.",
		"context": "The drawdown is used to check that the primary storage volume between the aquastat and the bottom of the effective storage volume is large enough that the primary HPWHs can cycle for at least 10 minutes without any hot water draws. Having a cycling volume greater than this minimum helps build a robust CHPWH system and adds some safety in the storage volume.",
		"AbsMin": 70,
		"ExpMin": 70,
		"ExpMax": 100,
		"AbsMax": 100,
		"warningMin": "",
		"warningMax": "",
		"errors": {
			"oversized": "The minimum aquastat fraction is greater than 1. The storage efficency is likely too low for a practical system, we recommend increasing storage efficency to 80%."
		},
		"default": 85,
		"default_CA": 80
	},
	"aquastatFraction": {
		"label": "Aquastat Fraction",
		"desc": "The fraction of primary storage depleted when the primary HPWHs are triggered on",
		"definition": "This is the point in the entire primary storage volume where the temperature trigger (aquastat) for cycling on the heat pump water heaters is placed. The default is to place this aquastat so that 40% of the primary storage is used when the heat pump equipment is triggered to cycle on. This is controlled by where the aquastat port is on the storage equipment that is being purchased.",
		"context": "Decreasing the fraction will result in the HPWH running more frequently and a smaller primary storage volume.Increasing the fraction means less storage is available to provide hot water while the HPWH equipment is recharging the primary storage, and a larger storage volume.During load shift scenarios, you may decrease the fraction to decrease the total tank volume. The Ecosizer will notify you if the aquastat is too low to allow for the minimum cycling time of a HPWH.",
		"AbsMin": 25,
		"ExpMin": 25,
		"ExpMax": 45,
		"AbsMax": 45,
		"warningMin": "",
		"warningMax": "",
		"errors": {
			"low": "The aquastat fraction is from the bottom up and includes the inefficient part of the storage, where water is likely to remain colder. Currently the aquastat sensor is in the inefficient storage, so the HPWH's will run constantly. The aqaustat fraction should be greater than [100-percentUseable].",
			"oversized": "The aquastat fraction is too low in the storage system. We recommend increasing to a minimum of [x]."
		},
		"default": "40",
		"default_CA": ""
	},
	"lsShed_AquaFrac": {
		"label": "Shed Aquastat Fraction",
		"desc": "The fraction of primary storage depleted when the primary HPWHs are triggered on during a shed period",
		"definition": "This is the point in the entire primary storage volume where the temperature trigger (aquastat) for cycling on the heat pump water heaters is placed during a shed period.",
		"context": "Decreasing the fraction will result in the HPWH running more frequently and a smaller primary storage volume.Increasing the fraction means less storage is available to provide hot water while the HPWH equipment is recharging the primary storage, and a larger storage volume.During load shift scenarios, you may decrease the fraction to decrease the total tank volume. The Ecosizer will notify you if the aquastat is too low to allow for the minimum cycling time of a HPWH.",
		"AbsMin": 25,
		"ExpMin": 25,
		"ExpMax": 85,
		"AbsMax": 85,
		"warningMin": "",
		"warningMax": "",
		"errors": {
			"low": "The aquastat fraction is from the bottom up and includes the inefficient part of the storage, where water is likely to remain colder. Currently the aquastat sensor is in the inefficient storage, so the HPWH's will run constantly. The aqaustat fraction should be greater than [100-percentUseable].",
			"oversized": "The aquastat fraction is too low in the storage system. We recommend increasing to a minimum of [x]."
		},
		"default": "80",
		"default_CA": ""
	},
	"lsLoadUp_AquaFrac": {
		"label": "Load Up Aquastat Fraction",
		"desc": "The fraction of primary storage depleted when the primary HPWHs are triggered on during a load up period",
		"definition": "This is the point in the entire primary storage volume where the temperature trigger (aquastat) for cycling on the heat pump water heaters is placed during a shed period.",
		"context": "Decreasing the fraction will result in the HPWH running more frequently and a smaller primary storage volume.Increasing the fraction means less storage is available to provide hot water while the HPWH equipment is recharging the primary storage, and a larger storage volume.During load shift scenarios, you may decrease the fraction to decrease the total tank volume. The Ecosizer will notify you if the aquastat is too low to allow for the minimum cycling time of a HPWH.",
		"AbsMin": 5,
		"ExpMin": 5,
		"ExpMax": 25,
		"AbsMax": 25,
		"warningMin": "",
		"warningMax": "",
		"errors": {
			"low": "The aquastat fraction is from the bottom up and includes the inefficient part of the storage, where water is likely to remain colder. Currently the aquastat sensor is in the inefficient storage, so the HPWH's will run constantly. The aqaustat fraction should be greater than [100-percentUseable].",
			"oversized": "The aquastat fraction is too low in the storage system. We recommend increasing to a minimum of [x]."
		},
		"default": "20",
		"default_CA": ""
	},
	"schematic": {
		"desc": "The design for the primary and temperature maintenance heating plants",
		"definition": "A <strong>Swing Tank</strong> design is a proven technique to use the primary heat pumps to support the temperature maintenance load, while keeping the heat pump equipment isolated from the warm water returning from the recirculation loop. This design strategy is best suited for buildings with low temperature maintenance loop losses (< 60W/apt) and relies on increased storage volume to ensure storage stratification. Swing tank systems have an electric resistance element in the temperature maintenance tank as a backup safety factor. Sizing a swing tank system also means increasing the heating capacity and storage volume of the primary system. The temperature maintenance storage volume for the swing tank can be small since it exists to seperate the temperature maintenance load from the primary storage volume.Single-pass heat pump water heaters are most efficient when heating cool city water to hot storage temperatures, whereas multi-pass equipment can still operate efficiently when incoming water temperatures are around 120F. A parallel loop configuration is one strategy used to isolate the temperature maintenance task from the task of heating the primary storage. A <strong>Parallel Loop Tank</strong> is an electric resistance element or a multi-pass heat pump that is piped in parallel with the primary system, specifically to handle the temperature maintenance load.<strong>Primary - No Recirculation</strong> is used for sizing a primary plant only."
	},
	"primary": {
		"label": "Primary - No Recirculation",
		"desc": "Just the primary plant without a temperature maintenance load",
		"definition": "Primary - No Recirculation is used for sizing a primary plant only."
	},
	"swingtank": {
		"label": "Swing Tank",
		"desc": "Primary plant with a temperature maintenance plant in series",
		"definition": "A <strong>Swing Tank</strong> design is a proven technique to use the primary heat pumps to support the temperature maintenance load (Banks et al., 2020), while keeping the heat pump equipment isolated from the warm water returning from the recirculation loop. This design strategy is best suited for buildings with low temperature maintenance loop losses (< 60W/apt) and relies on increased storage volume (with tanks piped in series) to ensure storage stratification. Swing tank systems have an electric resistance element in the temperature maintenance tank as a backup safety factor. Sizing a swing tank system also means increasing the heating capacity and storage volume of the primary system. The temperature maintenance storage volume for the swing tank can be small.",
		"reference": "<ul><li>Banks, A, Grist, C., and J. Heller. 2020. CO2 Heat Pump Water Heater Multifamily Retrofit: Elizabeth James House, Seattle WA. Prepared for Washington State University Energy Program, under contract to Bonneville Power Administration</li></ul>"
	},
	"paralleltank": {
		"label": "Parallel Loop Tank",
		"desc": "Primary plant with a temperature maintenance plant in parallel",
		"definition": "Single-pass heat pump water heaters are most efficient when heating cool city water to hot storage temperatures, whereas multi-pass equipment can still operate efficiently when incoming water temperatures are around 120F. A parallel loop configuration is one strategy used to isolate the temperature maintenance task from the task of heating the primary storage. A parallel loop tank is an electric resistance element or a multipass heat pump that is piped in parallel with the primary system, specifically to handle the temperature maintenance load."
	},
	"RLHLmethod": {
		"label": "Recirculation Loop Heat Loss Method",
		"label_trunc": "",
		"desc": "Input estimated temperature maintenance load or measured recirculation loop flow rate and temperature change",
		"definition": "This option allows you to toggle between inputting the recirculation loop heat loss rate in terms of Watts/apartment unit, or by inputting the recirculation loop pump flow rate and the recirculation loop return water temperature. The recirculation loop pump flow rate and return water temperature are used to calculate the heat loss rate."
	},
	"Wapt": {
		"label": "Recirculation Loop Heat Loss",
		"label_trunc": "Heat Loss",
		"desc": "The temperature maintenance load normalized by the number of apartments",
		"definition": "These are the losses associated with the recirculation loop expressed in Watts/apartment unit. Previously studied buildings show a median loss value close to 100 W/apt, with a 25th percentile of ~66W/apt, and a 75th percentile of ~175W/apt. Ideally, building and plumbing design will minimize this load. This is an area of building science that deserves additional research to better understand typical recirculation losses, and how to minimize them.",
		"context": "Increasing the recirculation loop heat loss rate will increase the temperature maintenance load expected and thus increase the temperature maintenance heating capacity and storage volume.",
		"reference": "<ul><li>Kintner P., and B. Larson (2019). <i>Literature Review of Multifamily Central Domestic Hot Water Distribution Losses.</i> Prepared for NEAA.</li></ul>",
		"AbsMin": 0.01,
		"ExpMin": 30,
		"ExpMax": 175,
		"AbsMax": 600,
		"warningMin": "30 Watts per apartment or below would be an exceptional building. The median building has 100 W/Apt, see Kintner and Larson (2019).",
		"warningMax": "175 Watts per apartment or above is a poor design for a new building. We recommend taking steps to ensure a smaller value.",
		"default": 100,
		"default_CA": 100
	},
	"recircFlow": {
		"label": "Recirculation Loop Flow Rate",
		"label_trunc": "Flow Rate",
		"desc": "The pump flow rate of the recirculation loop",
		"definition": "The recirculation loop flow rate is the rate at which a recirculation pump moves hot water through the distribution loop in gallons per minute.",
		"context": "This is used along with the recirculation loop return temperature to calculate the recirculation loop heat loss rate.",
		"AbsMin": 0.01,
		"ExpMin": 0.50,
		"ExpMax": 50,
		"AbsMax": 100,
		"warningMin": "",
		"warningMax": "",
		"default": "",
		"default_CA": ""
	},
	"recircTemp": {
		"label": "Recirculation Loop Return Temperature",
		"label_trunc": "Return Temperature",
		"desc": "Hot water temperature when returning from the recirculation loop",
		"definition": "The recirculation loop return temperature is the temperature of hot water when it returns to the temperature maintenance plant.",
		"context": "This is used along with the recirculation loop flow rate to calculate the recirculation loop heat loss rate.",
		"AbsMin": 32,
		"ExpMin": 100,
		"ExpMax": 125,
		"AbsMax": 212,
		"warningMin": "",
		"warningMax": "",
		"default": "",
		"default_CA": ""
	},
	"TMSafetyFactor": {
		"label": "Temperature Maintenance System Safety Factor",
		"label_trunc": "Temperature Maintenance<br>System Safety Factor",
		"desc": "How much greater the temperature maintenance heating capacity is over the load",
		"definition": "The safety factor the temperature maintenance heater will have over the temperature maintenance load.",
		"context": "A higher safety factor will increase the output of the temperature maintenance heater. If the safety factor was set to 1, the temperature maintenance heater and the temperature maintenance load would be in perfect balance.",
		"AbsMin": 1.0,
		"ExpMin": 1.0,
		"ExpMax": 4.5,
		"AbsMax": 10,
		"warningMin": "Warning: as the saftey factor approaches 1 the temperature maintenance heater risks not being able to cover the load. A typical value is somewhere between 1.2 and 2.",
		"warningMax": "",
		"default": 1.75,
		"default_CA": 1.75
	},
	"TMonTemp": {
		"label": "Temperature Maintenance Turn On",
		"label_trunc": "Temperature Maintenance Turn&nbsp;On",
		"desc": "The bottom of the deadband for the temperature maintenance plant",
		"definition": "This term, the Temperature Maintenance Setpoint, and the Cycle Off Time are critical to sizing a multi-pass heat pump water heater system. The Temperature Maintenance Turn On is the temperature of the water that will trigger the temperature maintenance to begin a heating cycle. In other words, the lowest temperature to which the temperature maintenance tank should be allowed to drop. This cannot be less than the supply temperature.",
		"AbsMin": 115,
		"ExpMin": 120,
		"ExpMax": 175,
		"AbsMax": 212,
		"warningMin": "",
		"warningMax": "",
		"default": 125,
		"default_CA": ""
	},
	"setpointTM": {
		"label": "Temperature Maintenance Setpoint",
		"label_trunc": "Temperature Maintenance Setpoint",
		"desc": "The setpoint of the temperature maintenance plant",
		"definition": "This term, the Temperature Maintenance Turn On, and the Cycle Off Time are critical to sizing a multi-pass heat pump water heater system. The Temperature Maintenance Setpoint is the temperature of the water serving the recirculation loop supply.",
		"context": "Increasing the temperature maintenance setpoint while holding the temperature maintenance turn on temperature (at 125F) will decrease the temperature maintenance tank volume as the stored energy density of the tank is greater.",
		"AbsMin": 115,
		"ExpMin": 125,
		"ExpMax": 185,
		"AbsMax": 212,
		"warningMin": "",
		"warningMax": "",
		"default": 135,
		"default_CA": ""
	},
	"offTime": {
		"label": "One Cycle Off Time",
		"label_trunc": "One Cycle<br>Off Time",
		"desc": "How long the parallel loop HPWH is expected to be off for",
		"definition": "This controls the temperature maintenance tank volume and is the expected time (in hours) that the temperature maintenance equipment will be off between heating cycles. This is related to the difference between the Temperature Maintenance Setpoint and Turn On temperatures, and the Recirculation Loop Heat losses. In other words, the time that will elapse as the loop losses reduce the tank temperature from the setpoint to the temperature that will trigger the heat pump water heater to cycle on.",
		"AbsMin": 0.01,
		"ExpMin": 0.33,
		"ExpMax": 6,
		"AbsMax": 23,
		"warningMin": "One Cycle Off Time is limited to 0.33 hours to prevent short cycling the HPWH.",
		"warningMax": "",
		"default": 0.33,
		"default_CA": ""
	},
	"loadShift": {
		"label": "Load Shift Sizing",
		"desc": "Select hours of day to exclude operation",
		"definition": "The load shift function allows you to block out part of the day when the heat pump water heaters will not run. The storage volume and heating capacity necessary to meet the load is sized similarly as in the primary system but accounting for period(s) where the heat pump water heaters will not run as requested by utility signals. This necessarily means that the storage volume must be higher so that the volume in the primary storage can provide the building occupants with hot water for the period when the heat pumps are prevented from running, and can meet any peaks after the end of the load shift period(s).",
		"context": "Load shift systems can grow quite large, in part due to the aquastat fraction being larger than needed. The aquastat fraction can be turned down in many load shift cases to account for a much larger than needed volume for the HPWH to cycle through."
	},
	"LSperiod1": {
		"label": "Period 1",
		"default": "6,10"
	},
	"LSperiod2": {
		"label": "Period 2",
		"default": "16,21"
	},
	"loadShift_percent": {
		"label": "Percent of Load Shift Captured",
		"desc": "Set the percentage of days the load shift will be met",
		"definition": "This adjusts the percent of days to meet the hot water demands of load shifting. For example, turning this down to 70% implies that only 70% of days will meet the hot water demand from load shift. This is achieved by scaling down the daily gallons per person to the 70th percentile value following a distribution acquired from 4 years of data from a market rate building in Seattle, WA. The median value at the 50th percentile is about 70% of the 100th percentile load.",
		"AbsMin": 25,
		"ExpMin": 25,
		"ExpMax": 100,
		"AbsMax": 100,
		"context": "Note that your storage requirement increases exponentially with increased load shift, represented by the curve behind the slider. So the closer to 100% you get, the larger the impact will be on storage requirements.",
		"default": 95,
		"default_CA": 95
	},
	"loadup_hours": {
		"label": "Load Up Hours",
		"desc": "The load up hours for load shift advanced options",
		"definition":"The number of hours it will take the system to Load Up the storage after turning off in Normal Operation. This value may drive the required heating capacity if it is greater than the capacity needed to meet the daily load.",
		"AbsMin": 1,
		"AbsMax": 6
	},
	"single_pass": {
		"label": "Single Pass",
		"desc": "Single pass refers to high temperature lift equipment",
		"definition": "Single pass equipment draws water from the bottom of the tank and heats to setpoint in one pass through the HPWH, returning the hot water to the top of the tank and maximizing stratification."
	},
	"multi_pass": {
		"label": "Multi Pass",
		"desc": "Multi Pass refers to low temperature lift equipment",
		"definition": "Multipass equipment can be a split system which draws and returns water near the bottom of the tank, similar piping to a gas boiler, or unitary equipment where the condenser is wrapped around the tank. Multipass HPWHs heat water in stages as opposed to a single pass through the HPWH and are typically less stratified"
	},
	"singlepass_rtp": {
		"label": "Single pass return to primary label",
		"desc": "Single Pass refers to low temperature lift equipment",
		"definition": "Single pass equipment can be a split system which draws and returns water near the bottom of the tank, similar piping to a gas boiler, or unitary equipment where the condenser is wrapped around the tank. Multipass HPWHs heat water in stages as opposed to a single pass through the HPWH and are typically less stratified"
	},
	"multipass_norecirc": {
		"label": "Multi Pass",
		"desc": "Multi Pass refers to low temperature lift equipment",
		"definition": "Multipass equipment can be a split system which draws and returns water near the bottom of the tank, similar piping to a gas boiler, or unitary equipment where the condenser is wrapped around the tank. Multipass HPWHs heat water in stages as opposed to a single pass through the HPWH and are typically less stratified"
	},
	"multipass_rtp": {
		"label": "Multi Pass",
		"desc": "Multi Pass refers to low temperature lift equipment",
		"definition": "Multipass equipment can be a split system which draws and returns water near the bottom of the tank, similar piping to a gas boiler, or unitary equipment where the condenser is wrapped around the tank. Multipass HPWHs heat water in stages as opposed to a single pass through the HPWH and are typically less stratified"
	},
	"singlepass_norecirc": {
		"label": "Primary - No Recirculation",
		"desc": "Just the primary plant without a temperature maintenance load",
		"definition": "Primary - No Recirculation is used for sizing a primary plant only."
	},
	"ecoport_commands": {
		"label": "EcoPort Commands",
		"definition": "To achieve load shifting, heat pump water heaters need to change their operation throughout the day, charging thermal storage before a shift and riding through shift periods using storage hot water. Heat pump water heaters will receive a signal through an EcoPort (defined by CTA-2045-B) or equivalent communication instrument, but the control system needs to be programmed to respond to the commands. At a minimum, heat pump water heating systems need control changes that correspond to Normal, Load Up, and Shed commands defined in this table."
	},
	"normal_controls": {
		"label": "Normal Controls",
		"definition": "Normal operating controls when no command is sent or a return to normal command is sent to the system."
	},
	"hpwh_outlet": {
		"label": "HPWH Outlet",
		"definition": "HPWH Outlet is the temperature of the water generated by the HPWH, which may be increased during load up to store water at a higher energy density The HPWH outlet temperature will influence the water temperature in the top of the tank that is leaving the tank and being sent to a swing tank and/or thermostatic mixing valve."
	},
	"setpoint": {
		"label": "Setpoint",
		"definition": "Setpoint is the temperature of the water generated by the HPWH. Under Normal operation it is the same as the Hot Storage Temperature, but it may be increase during load up to storage water at a higher energy density."
	},
	"on_trigger": {
		"label": "ON-Trigger",
		"definition": "ON-Trigger is a suggested temperature setpoint that will turn the heat pump water heater ON at the aquastat fraction indicated (i.e. aquastat setpoint and start of recovery cycle). The current value is not used in sizing and only a suggestion. The engineer and manufacturer should be consulted on appropriate values to prevent short cycling while still achieving load shift."
	},
	"off_trigger": {
		"label": "OFF-Trigger",
		"definition": "OFF-Trigger is a suggested temperature setpoint that will turn the heat pump water heater OFF at the aquastat fraction indicated (i.e. completion of recovery cycle). The current value is not used in sizing and only a suggestion. The engineer and manufacturer should be consulted on appropriate values to prevent short cycling while still achieving load shift."
	},
	"loadUp_hours": {
		"label": "Load Up Hours",
		"definition": "The maximum number of hours it could take the system to heat the storage tank during a Load Up command (i.e. the number of hours for the % volume of the tank to be at or above setpoint, based on the load up aquastat fraction and OFF-trigger)  This value may drive the required heating capacity if it is greater than the capacity needed to meet the daily load."
	},
	"aquastat_controls": {
		"label": "Aquastat Fraction",
		"definition": "The heat pump water heaters are controlled to turn on and off with temperature sensors located in the storage tank -- these are called aquastats. The aquastat fraction is the % of the tank water volume that is allowed to fall below the aquastat's setpoint before the heat pump begins an ON-Trigger. Installing three temperature sensors -- at the top (65-85% of volume), middle (30-45% of tank volume), and bottom (10-25%  of tank volume) -- allows for effective management of the heat pump water heaters operations during shed, normal, and load up operating modes respectively."
	},
	"loadUp_controls": {
		"label": "Load Up Controls",
		"definition": "Controls corresponding to CTA-2045-B defined Load Up and Advanced Load Up. Typically systems decrease the Aquastat Fraction (i.e. a smaller % volume of the tank is below aquastat setpoint) and increase the heat pump water heaters outlet temperature setpoint (if possible)."
	},
	"shed_controls": {
		"label": "Shed Controls",
		"definition": "Controls corresponding to CTA-2045-B defined Shed and Critical Peak Event. Typically the system increases the Aquastat fraction to achieve a longer period without electrical use (i.e. a larger % volume of the tank is allowed to be below setpoint). Electric resistance elements should be locked out during a Shed Event. Electric resistance can be locked out with a relay or other control.",
		"context": "Grid Emergency, defined by CTA-2045-B should turn off the system completely."
	},
	"gasHeater_controls": {
		"label": "Gas Heater Controls",
		"definition": "Controls for the gas backup heater used in the Gas in Parallel piping configuration. The gas heater's aquastat fraction and ON/OFF-Trigger temperatures determine when it fires to supplement the primary HPWH. Its outlet temperature always matches the Normal outlet temperature."
	},
	"start_month": {
		"label": "Start Month",
		"definition": "The start month of the billing period. The first row in the billing table should have this input set to January."
	},
	"peak_hours": {
		"label": "Peak Hours",
		"definition": "The hours (range 0 to 24) that peak pricing is applicable to the billing schedule. Typically, this is the time of the day when larger demand and energy pricing is present in utility billing due to higher need for power consumption in the municipality. Input must be formatted as '[start hour]-[end hour]'."
	},
	"end_month": {
		"label": "End Month",
		"definition": "The end month (inclusive) of the billing period. The last row in the billing table should have this input set to December."
	},
	"peak_demand": {
		"label": "Peak Demand Pricing",
		"definition": "The demand pricing during the peak period in dollars per kW."
	},
	"peak_energy": {
		"label": "Peak Energy Pricing",
		"definition": "The energy pricing during the peak period in dollars per kWh."
	},
	"off_peak_demand": {
		"label": "Off-Peak Demand Pricing",
		"definition": "The demand pricing during the off-peak period in dollars per kW."
	},
	"off_peak_energy": {
		"label": "Off-Peak Energy Pricing",
		"definition": "The energy pricing during the off-peak period in dollars per kWh."
	},
	"numberPrimHPWH" :{
		"label": "Number of Primary HPWHs",
		"label_trunc": "Number of Primary HPWHs",
	},
	"tmNumheatPumps": {
		"label": "Number of Temperature Maintenance HPWHs",
		label_trunc: "Number of Temperature Maintenance HPWHs",
	},
	"primaryStorageVol": {
		"label": "Primary Storage Volume (Gallons)",
		label_trunc: "Primary Storage Volume (Gallons)",
	},
	"swingTankElement": {
		"label": "Swing Tank Element (kW)",
		label_trunc: "Swing Tank Element (kW)",
	},
	"tempMaintStorageVol": {
		"label": "Temperature Maintenance Storage Volume (Gallons)",
		label_trunc: "Temperature Maintenance Storage Volume (Gallons)",
	},
	"numHeatPumps": {
		"label": "Number of Primary HPWHs",
		"label_trunc": "Number of Primary HPWHs",
	},
	"externalT_F": {
		label_trunc: "Design Outdoor Air Temp",
	},
	"PCap_kW": {
		label_trunc: "Primary Capacity (kW)",
	},
	PVol_G_atStorageT: {
		label_trunc: "Primary Storage Volume (Gallons)",
	},
	TMVol_G: {
		label_trunc: "Swing Tank Storage (Gallons)",
	},
	defrost_derate: {
		label_trunc: "Defrost Derate at Design Air Temp (%)",
	},
	HPWHModelSP: {
		label_trunc: "Heat Pump Water Heater Model",
	},
	HPWHModelMP: {
		label_trunc: "Heat Pump Water Heater Model",
	},
	"baseUtilityMonthlyCharges": {
		"label_trunc": "Base Charges ($/month)",
		"label": "Base Charges",
		"definition": "The base monthly cost for the building to be connected to the city power grid."
	},
}
